import { render } from "./AssignExclusivePublishingPlatformModal.vue.js?vue&type=template&id=4a96c82e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AssignExclusivePublishingPlatformModal.vue?vue&type=template&id=4a96c82e"
import script from "./AssignExclusivePublishingPlatformModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AssignExclusivePublishingPlatformModal.vue?vue&type=script&lang=js"
export * from "./AssignExclusivePublishingPlatformModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AssignExclusivePublishingPlatformModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/AssignExclusivePublishingPlatformModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a96c82e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a96c82e', __exports__)) {
    api.reload('4a96c82e', __exports__)
  }
  
  module.hot.accept("./AssignExclusivePublishingPlatformModal.vue.js?vue&type=template&id=4a96c82e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AssignExclusivePublishingPlatformModal.vue?vue&type=template&id=4a96c82e", () => {
    api.rerender('4a96c82e', render)
  })

}


export default __exports__